import { Avatar } from "primereact/avatar";
import { Menu } from "primereact/menu";
import { useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import usePermissions from "../../../../common/api/usePermissions";
import { Modal } from "../../../../common/components";
import ProfileModal from "../../../profile/components/ProfileModal/ProfileModal";
import { useNotificationsStore } from "../../../user-notifications/store";
import { useUserStore } from "../../../users/store";

interface UserMenuProps {
    onLogoutClick?: () => void;
}

const UserMenu = (props: UserMenuProps) => {
    const { onLogoutClick = () => {} } = props;

    const { t } = useTranslation("common");

    const { user } = useUserStore();
    const { hasPermissions } = usePermissions();
    const { openEmailNotificationModal } = useNotificationsStore();

    const menuLeft = useRef(null);
    const [isConfirmingLogout, setIsConfirmingLogout] = useState(false);
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);

    const handleLogout = () => {
        setIsConfirmingLogout(true);
    };

    const cancelLogout = () => {
        setIsConfirmingLogout(false);
    };

    const menuItems = useMemo(() => {
        const items = [
            {
                label: t("profile"),
                icon: "pi pi-user",
                command: () => setIsProfileModalOpen(true),
            },
            {
                label: t("logout"),
                icon: "pi pi-sign-out",
                command: () => handleLogout(),
            },
        ];

        if (!hasPermissions()) {
            items.splice(1, 0, {
                label: t("emailNotifications.editNotifications") || "",
                icon: "pi pi-envelope",
                command: () => openEmailNotificationModal(),
            });
        }

        return items;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, t]);

    return (
        <>
            <Menu model={menuItems} popup ref={menuLeft} id="popup_menu_left" />
            <Avatar
                className="ml-3.5 size-8 rounded-full bg-surface-500/25 text-primary-text"
                icon="pi pi-user"
                shape="circle"
                label={user?.username?.[0]}
                onClick={(event) =>
                    (menuLeft.current as Menu | null)?.toggle(event)
                }
            />
            <Modal
                title={t("logout")}
                isOpen={isConfirmingLogout}
                hasCancelButton
                hasOkButton
                okText={t("yes")}
                cancelText={t("cancel")}
                onClickOk={onLogoutClick}
                onClickCancel={cancelLogout}
                onClickClose={cancelLogout}
            >
                {t("questionLogout")}
            </Modal>
            <ProfileModal
                isOpen={isProfileModalOpen}
                onClose={() => setIsProfileModalOpen(false)}
            />
        </>
    );
};

export default UserMenu;
